import React, { useEffect, useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import OrderCanvasModal from './OrderCanvasModal';
import { useCanvasCart } from '../hooks/useCanvasCart';

/** Floating "Cart · N items" pill that appears anywhere on the site while
 * the user has canvases in their cart. Tapping it re-opens the order modal
 * on the cart step so they can checkout with combined shipping. */
export const CanvasCartPill = () => {
  const { cart } = useCanvasCart();
  const [open, setOpen] = useState(false);

  // Hide on mobile bottom safe-area (respected by our nav bar), otherwise
  // hovering over the bottom nav.
  const first = cart[0];

  if (cart.length === 0) return (
    <>
      {open && first && (
        <OrderCanvasModal
          imageUrl={first.image_url}
          imageLabel={first.label}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );

  const total = cart.reduce((s, i) => s + (i.cost_usd || 0), 0);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-24 sm:bottom-6 right-4 sm:right-6 z-40 flex items-center gap-2 px-4 py-3 bg-[#9a7b24] hover:bg-[#c9a43a] text-white rounded-full shadow-2xl font-bold transition-all animate-in slide-in-from-bottom"
        data-testid="canvas-cart-pill"
        style={{ boxShadow: '0 8px 24px rgba(154,123,36,0.35)' }}
      >
        <ShoppingCart className="w-4 h-4" />
        <span>Cart · {cart.length}</span>
        <span className="text-white/80 font-normal">${total.toFixed(2)}</span>
        <span className="hidden sm:inline text-xs bg-white/20 rounded px-2 py-0.5">Checkout</span>
      </button>
      {open && first && (
        <OrderCanvasModal
          imageUrl={first.image_url}
          imageLabel={first.label}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default CanvasCartPill;
